import axios from "axios";
const uri = "https://www.lefisc.com.br/api/ApiEsocialPrazoEnvio/APIesocial";
const tok = "cf97787d-c3cc-475f-85f4-8570c7470794";

export default{
    getAll(complementoRota){
        return axios
                .get(`${uri}/${complementoRota}/${tok}`)
                .then(res => {
                    return res.data;
                })
                .catch(err => console.error(err));
    },
    getBusca(complementoRota, texto){
        return axios
            .post(`${uri}/${complementoRota}/${tok}`, texto)
            .then(res => {
                return res.data;
            })
            .catch(err => console.error(err));
    }
} 


// WEBPACK FOOTER //
// ./src/services/prazoEnvioService.js